import React, { useState, useRef } from 'react';

const Filter = ({
  sort_option,
  sortOptions,
  ecommerce_config,
  openModalFilterCategory,
  setSortOption,
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const buttonRef = useRef(null);

  const selectedSortOptionObj = sortOptions.find((sort) => sort.name === sort_option);
  const selectedSortOption = selectedSortOptionObj ? selectedSortOptionObj.displayName : '';

  const handleToggle = () => setIsOpened((prev) => !prev);

  const dropdownWidth = buttonRef.current && buttonRef.current.offsetWidth ? buttonRef.current.offsetWidth : 185;

  return (
    <section className="plans-filtering-section">
      <ul className="plans-filtering-list">
        {ecommerce_config.filter && (
          <li>
            <button
              type="button"
              className="btn-filter categoria-filtro"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (typeof openModalFilterCategory === 'function') openModalFilterCategory();
              }}
              data-cy="filtrar"
            >
              <span>
                <img src="/assets/images/icons/filter.svg" alt="Icone filtro" />
                Filtrar por
              </span>
            </button>
          </li>
        )}
        <li>
          {isOpened && <div className="overlay-dropdown" onClick={handleToggle} aria-hidden="true" />}
          <div className="filter-dropdown" data-cy="filtro-ordenar">
            <button ref={buttonRef} className="btn-filter ordenar-filtro" onClick={handleToggle}>
              <span>
                <img src="/assets/images/icons/switch.svg" alt="Icone shape" className="icon-shape-filtro" />
                <span>{selectedSortOption}</span>
              </span>
              <img
                src="/assets/images/icons/arrowUp.svg"
                alt="Icon arrow"
                className={`icon-arrow-filtro-${isOpened ? 'open' : ''}`}
              />
            </button>
            {isOpened && (
              <div
                className="filter-dropdown-content open"
                style={{ width: `${dropdownWidth}px`, maxWidth: 'none' }}
                onClick={handleToggle}
              >
                {sortOptions.map((option, index) => (
                  <button
                    key={index}
                    className={`filter-dropdown-item ${index > 0 ? 'filter-divider' : ''}`}
                    onClick={() => setSortOption(option.name)}
                  >
                    {option.displayName}
                  </button>
                ))}
              </div>
            )}
          </div>
        </li>
      </ul>
    </section>
  );
};

export default Filter;



// WEBPACK FOOTER //
// ./src/components/search/plans_table/Filters/Filter.jsx